export default "__VITE_ASSET__BsixjO1d__"